import { SVGAttributes } from 'react';

import { Color } from '../internal/types/designSystemTypes';
import { cn } from '../lib/css/className/className';
import { VerticalAlignAddonSize } from '../hooks/useVerticalAlign';

export const iconCls = cn('Icon');

export type IconRole = 'main' | 'supplementary';

/** Доступные в дизайн системе размеры иконок */
export type IconSize = VerticalAlignAddonSize | '28' | '32' | '40' | '48' | '64' | '96' | '120' | '240';

/**
 * Общие свойства svg-иконок
 */
export interface IconBaseProps extends SVGAttributes<SVGSVGElement> {
    /**
     * Названия классов для элемента
     */
    className?: string;

    /**
     * Размер иконки
     * @default '16'
     */
    size?: IconSize;

    /**
     * Заголовок иконки, отображаемый как нативный тултип при наведении.
     * Добавляется как элемент `<title>` внутри SVG
     */
    title?: string;
}

/**
 * Свойства для бесцветных (перекрашиваемых) svg-иконок
 */
export interface ColorlessIconProps extends IconBaseProps {
    /**
     * Роль элемента: основной (main) или второстепенный (supplementary).
     * От роли зависят цветовые стили элемента
     * @default 'supplementary'
     */
    role?: IconRole;

    /**
     * Цветовое оформление иконки в соответствии с дизайн-системой
     * @default undefined
     */
    color?: IconColor | 'current';
}

export interface LogoProps {
    view?: 'dark' | 'light';
    width?: string;
    height?: string;
    alt?: string;
}
export type IconColor = Exclude<Color, 'yellow-2'>;
